import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TaskService } from '@services/lm/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import dayjs from 'dayjs';
import { Project } from '@app/interfaces/lm/project';
import { TaskCreateFormComponent } from '../task-create-form/task-create-form.component';
import { TaskConfig, TaskLabel, TaskSwimLane } from '@app/interfaces/lm/kanban-board';
import { KanbanBoardService } from '@services/lm/kanban-board.service';

@Component({
    selector: 'app-task-create',
    templateUrl: './task-create.component.html',
    styleUrls: ['./task-create.component.less']
})
export class TaskCreateComponent {
    @Input() taskConfigs: TaskConfig[] = [];
    @Input() projectId!: string;
    @Input() taskId!: string;
    @Input() taskSwimLanes: TaskSwimLane[] = [];
    @ViewChild('taskForm') taskForm: TaskCreateFormComponent | undefined;
    @Output() success = new EventEmitter();

    isVisible = false;
    submitLoading = false;

    constructor(private kanbanBoardService: KanbanBoardService,
        private message: NzMessageService) { }

    open(): void {
        this.isVisible = true;
    }

    close(): void {
        this.isVisible = false;
    }

    async onSubmit(): Promise<void> {
        try {
            this.submitLoading = true;
            const form = this.taskForm?.validForm();
            if (form) {
                const { parentTaskId, startDate, dueDate } = form;
                const formatStartDate = (date: string) => {
                    const dateObj = new Date(date);
                    dateObj.setUTCHours(9, 0, 0, 0);
                    return dateObj.toISOString();
                };
                const formatDueDate = (date: string) => {
                    const dateObj = new Date(date);
                    dateObj.setUTCHours(17, 0, 0, 0);
                    return dateObj.toISOString();
                };
                if (startDate) {
                    form.startDate = formatStartDate(startDate);
                }
                if (dueDate) {
                    form.dueDate = formatDueDate(dueDate);
                }
                parentTaskId ? await this.kanbanBoardService.addSubTask(form) :
                    await this.kanbanBoardService.addTask(form);
                this.message.success('Added successfully');
                this.close();
                this.success.emit();
            }
        } finally {
            this.submitLoading = false;
        }
    }
}
